import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { AiSource } from "components/ai_chat/types";
import { WinTheme } from "components/bid_module/win_themes/AddEditWinThemeDrawer";
import AiSources from "lib/core_components/ai/AiSources";
import { AnswerMarkdown } from "lib/core_components/ai/AnswerMarkdown";
import { BidDetails } from "lib/hooks/api/bid/bids/useBid";
import { AiContextProvider } from "lib/providers/AiContextProvider";

type Props = {
  bidId: string;
  bidName: string;
  winThemes: BidDetails["winThemes"];
  onThemeClick?: (theme: WinTheme) => void;
  disableLinks?: boolean;
};

export function WinThemeList({
  bidId,
  bidName,
  winThemes,
  onThemeClick,
  disableLinks = false,
}: Props) {
  return (
    <AiContextProvider
      context={{
        resourceId: bidId,
        resourceName: bidName || "Bid",
        resourceType: "BID_WIN_THEMES",
        bidId,
      }}
    >
      <Flex column gap={24}>
        {winThemes?.length ? (
          winThemes.map((theme) => {
            const sources = (theme.sources ?? []) as AiSource[];
            return (
              <WinThemeCard
                key={theme.id}
                onClick={onThemeClick ? () => onThemeClick(theme) : undefined}
                $interactive={!!onThemeClick}
              >
                <Text h3>{theme.title}</Text>
                <AnswerMarkdown answer={theme.description} sources={sources} />
                {sources.length > 0 && !disableLinks && <AiSources sources={sources} />}
              </WinThemeCard>
            );
          })
        ) : (
          <Text description>No win themes found for this bid.</Text>
        )}
      </Flex>
    </AiContextProvider>
  );
}

const WinThemeCard = styled(Flex)<{ $interactive: boolean }>(({ theme, $interactive }) => ({
  flexDirection: "column",
  gap: 8,
  padding: 16,
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  borderRadius: 4,
  ...($interactive && {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.colors.sysPrimarySubtle,
    },
  }),
}));
